enum NotificationType {
    MbiVerification,
    ApplicationSuccess,
    ApplicationSuccessMbiVerificationRequired,
    MbiSuccessfullyUpdated,
    PendingApplicationReviewReminder,
    PendingApplicationDeclined,
    AhpCertificationOpen,
    CertificationOrTrainingOverdue,
    ExpiringLicenses,
    EnrollmentStatusUpdate,
}

export default NotificationType;
